import { Link } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

export default function MissingMMPDocMessage(childId: number) {
  const useStyles = makeStyles()(() => ({
    link: {
      fontSize: "16px",
      textDecoration: "underline !important",
      color: "inherit",
    },
  }));

  const { classes } = useStyles();

  return (
    <>
      Bookings are currently unavailable, we require a medical management plan to be uploaded before your child can
      attend a session. Head to the Medical Conditions section{" "}
      <Link to={`/edit-child/${childId}`} className={classes.link}>
        here
      </Link>{" "}
      to upload one.
    </>
  );
}
